<template>
  <div id="bandeau-component" v-if="content">
    <div id="bandeau" v-if="content.display">
      <p class="text" v-html="content.text"></p>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      content: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { data } = await api.get(
        `cdn/stories?starts_with=${this.$i18n.locale}/bandeau`
      );
      this.content = data.stories[0].content;
    }
  }
};
</script>


<style lang="scss">
#bandeau {
  background-color: #faa61a;

  width: 100%;
  //position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  //animation: slide-in-top 1s ease-in-out 4s both;
  z-index: 1;
  .text {
    color: $black;
    text-align: center;
    align-items: center;
    padding: 1em 0;
    font-weight: 800;
  }

  @keyframes slide-in-top {
    0% {
      transform: translateY(-200px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media screen and (max-width: $desktop) {
    .text {
      padding: 1em;
    }
  }
}
</style>
